module.exports = __webpack_public_path__ + "img/kjds.d07d488f.svg";